import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { CONTACT } from "../data";

export const FreeEstimate = () => {
  return (
    <section data-testid="free-estimate-banner" className="py-20 sm:py-24 bg-brand-bg">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="rounded-[2rem] bg-brand-olive px-7 py-14 sm:px-14 sm:py-16 text-center relative overflow-hidden"
        >
          <div className="relative z-10">
            <p className="text-brand-bg/80 font-semibold tracking-widest uppercase text-sm mb-4">
              Ready to start?
            </p>
            <h2 className="font-display font-extrabold text-[#FCFAF6] text-3xl sm:text-5xl tracking-tight leading-tight">
              Get Your Free Estimate
            </h2>
            <p className="mt-4 text-[#F1EFE4] text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
              Tell me what you need — and I&apos;ll get it done. No job too small,
              or too complicated.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={CONTACT.phoneRaw}
                data-testid="estimate-call-button"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-brown px-8 py-4 font-semibold text-brand-bg hover:bg-brand-brownDark hover:scale-105 transition-all shadow-lg"
              >
                <Phone size={18} /> Call {CONTACT.phoneDisplay}
              </a>
              <a
                href={CONTACT.emailLink}
                data-testid="estimate-email-button"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#FCFAF6] px-8 py-4 font-semibold text-brand-brown hover:scale-105 transition-all shadow-lg"
              >
                <Mail size={18} /> Email Me
              </a>
            </div>

            <p className="mt-7 text-[#F1EFE4]/70 text-xs sm:text-sm">
              * T&amp;Cs apply — job needs to be worthwhile.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
